import { Rates } from "../assets/icons/icons";
import { classNames } from "@frontend/utils/utils";
import { usePage } from "@inertiajs/react";
import Toast from "../components/Toast";
import { UserCircleIcon, BuildingOffice2Icon, UsersIcon } from "@heroicons/react/24/outline";
import { PropsWithChildren } from "react";

const navigation = [
  { name: "Rates", href: "/cms/rates", icon: Rates, paths: ["/cms/rates"] },
  {
    name: "Utilities",
    href: "/cms/utilities",
    icon: BuildingOffice2Icon,
    paths: ["/cms/utilities"],
  },
  {
    name: "Users",
    href: "/cms/users",
    icon: UsersIcon,
    paths: ["/cms/users"],
    requiresSuperadmin: true,
  },
];

const LayoutWrapper = ({ children }: PropsWithChildren) => {
  const {
    url,
    props: { current_user, current_user_role },
  } = usePage();

  const visibleNavigation = navigation.filter((item) => !item.requiresSuperadmin || current_user_role === "superadmin");

  return (
    <>
      <div className="h-full bg-gray-900">
        <div className="fixed inset-y-0 z-50 flex w-[250px] flex-col">
          <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6">
            <div className="flex h-16 shrink-0 items-center mt-3">
              <a href="/cms/rates">
                <p className="text-white text-2xl font-semibold">BellaRates CMS</p>
              </a>
            </div>
            <nav className="flex flex-1 flex-col">
              <ul className="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul className="-mx-2 space-y-1">
                    {visibleNavigation.map((item) => (
                      <li key={item.name}>
                        <a
                          href={item.href}
                          className={classNames(
                            item.paths?.some((path) => url.startsWith(path))
                              ? "bg-gray-600 text-gray-200"
                              : "text-gray-200 hover:bg-gray-600",
                            "group flex gap-x-3 rounded-md p-3 text-sm leading-6 font-semibold items-center",
                          )}
                        >
                          <item.icon
                            className={classNames(
                              item.href === url ? "text-white" : "text-gray-200 group-hover:text-white",
                              "h-6 w-6 shrink-0",
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
          <a
            href="/cms/account"
            className={classNames(
              "/cms/account" === url ? "bg-gray-600 text-gray-200" : "text-gray-200 hover:bg-gray-600",
              "mb-4 mx-4 group flex gap-x-3 rounded-md p-3 text-sm leading-6 font-semibold items-center",
            )}
          >
            <UserCircleIcon
              className={classNames(
                "/cms/account" === url ? "text-white" : "text-gray-200 group-hover:text-white",
                "h-6 w-6 shrink-0",
              )}
              aria-hidden="true"
            />
            {current_user.email_address}
          </a>
        </div>
        <main className="pl-[250px] h-full w-full fixed">
          <div className="rounded-[40px] rounded-r-none bg-white mt-3 h-[calc(100%-12px)] shadow-md overflow-scroll">
            <div className="px-8 py-6">{children}</div>
          </div>
        </main>
      </div>

      <Toast />
    </>
  );
};

export default function Layout(page: any) {
  console.log("LAYOUT PAGE", page);

  return <LayoutWrapper>{page.children}</LayoutWrapper>;
}
